import { withStyles } from '@material-ui/core';
import CreateProfileButton from './CreateProfileButton';
import styles from './CreateProfileButton.styles';

export default withStyles(styles)(CreateProfileButton);
